import React, { useState } from "react";
import { useItemsFine } from "../../_actions/app/items";
import styles from "./styles/CommentsBox.module.css";
import {
    Button,
    Collapse,
    Dropdown,
    Input,
    message,
    Select,
    Space,
    theme,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useCreateItem, useUpdateItem } from "../../_actions/mutations/items";
import { DownOutlined, UserOutlined } from "@ant-design/icons";

const { Panel } = Collapse;
const { TextArea } = Input;

function CommentsBox({ template }) {
    const { isSuccess, isLoading, data } = useItemsFine(
        "qdb_comment",
        `filter[template][id][_eq]=${template.id}&sort=-date_created&fields=*,user_created.first_name,user_created.last_name`,
        true,
    );
    const [open_write, setOpenWrite] = useState(false);
    const [opened_panel, setOpenedPanel] = useState([]);

    return (
        <div>
            <Collapse
                activeKey={open_write ? ["comments"] : opened_panel}
                onChange={(data) => {
                    setOpenedPanel(data);
                    if (data?.length === 0) {
                        setOpenWrite(false);
                    }
                }}
            >
                <Panel
                    header={`Comments  (${data?.length})`}
                    key="comments"
                    extra={
                        <PlusOutlined
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenWrite(true);
                                setOpenedPanel(["comments"]);
                            }}
                        />
                    }
                >
                    {open_write ? (
                        <WriteComment
                            template={template}
                            onDone={() => {
                                setOpenWrite(false);
                                setOpenedPanel(["comments"]);
                            }}
                        />
                    ) : (
                        isSuccess &&
                        data?.length > 0 && (
                            <div className={styles.wrapper}>
                                {data.map((item) => (
                                    <OneComment key={item.id} comment={item} />
                                ))}
                            </div>
                        )
                    )}

                    {!open_write && isSuccess && data?.length === 0 && (
                        <span>No comments yet</span>
                    )}
                </Panel>
            </Collapse>

            <div styles={{ height: "15px" }}>.</div>
        </div>
    );
}

export default CommentsBox;

function OneComment({ comment }) {
    const mutationUpdate = useUpdateItem("qdb_comment", comment.id, () => {});
    const { token } = theme.useToken();

    return (
        <div
            className={styles.item_wrapper}
            style={{ borderBottom: `1px solid ${token.colorBorderSecondary}` }}
        >
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                {comment.user_created && (
                    <p
                        className={styles.user}
                        style={{ color: token.colorPrimary }}
                    >
                        {comment.user_created.first_name}{" "}
                        {comment.user_created.last_name}
                    </p>
                )}
                <StatusDropdown
                    value={comment.status}
                    onChange={(newVal) => {
                        mutationUpdate.mutate({
                            status: newVal,
                        });
                    }}
                    loading={mutationUpdate.isLoading}
                />
            </div>
            {/* {comment.title && <h4>{comment.title}</h4>} */}
            {comment.content && (
                <p style={{ color: token.colorTextSecondary }}>
                    {comment.content}
                </p>
            )}
            {/* <pre>{JSON.stringify(comment, null, 2)}</pre> */}
        </div>
    );
}

function WriteComment({ template, onDone }) {
    const [content, setContent] = useState("");
    const [status, setStatus] = useState("todo");
    const mutationCreate = useCreateItem("qdb_comment", onDone);

    const write = () => {
        if (!content || content.trim().length === 0) {
            message.warning("Don't leave comment empty, write a feedback");
            return; // Don't create comment if content is empty
        }
        console.log("template.id:", template?.id);
        mutationCreate.mutate({
            content: content,
            template: template?.id,
            ...(status !== "none" && { status: status }),
        });
    };

    return (
        <div className={styles.write_wrapper}>
            <TextArea
                rows={4}
                placeholder="Comment content"
                onChange={(e) => setContent(e.target.value)}
                value={content}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        write();
                    }
                }}
            />
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}
            >
                <Button
                    type="primary"
                    onClick={() => {
                        write();
                    }}
                >
                    Add Comment
                </Button>

                <StatusDropdown
                    value={status}
                    onChange={(val) => setStatus(val)}
                />
            </div>
        </div>
    );
}

export function StatusDropdown({ value, onChange, loading }) {
    return (
        <Select
            defaultValue={value}
            value={value}
            allowClear
            style={{ width: 120 }}
            onChange={(val) => onChange(val)}
            loading={loading}
            options={[
                { label: "⚪ None", value: "none" },
                { label: "🟡 ToDo", value: "todo" },
                { label: "🟠 In Progress", value: "in_progress" },
                { label: "🔵 Done", value: "done" },
                { label: "🟢 Ready", value: "ready" },
                { label: "🔴 On Hold", value: "on_hold" },
                { label: "📦 Archived", value: "archived" },
            ]}
        />
    );
}
